import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import FounderDealForm from 'components/global/FounderDealForm';
import { handleSubmitEditDeal } from 'components/views/FounderDeals/_helpers/founderDeals.events';
import { $view } from 'signals/global.signals';

const FounderEditDealModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-edit-deal'}
    title="Edit Raise"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitEditDeal}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <FounderDealForm />
  </SimpleModal>
);

export default FounderEditDealModal;
